import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const PreviousIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "previous",
  "PreviousIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M6 8L11.6667 12L11.6667 4L6 8Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M4.66667 11.6667L4.66667 4.33335L6 4.33335L6 11.6667L4.66667 11.6667Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default PreviousIcon;
